import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';

@Pipe({
  name: 'DistanceMiles'
})
export class DistanceMilesPipe implements PipeTransform {
  constructor(private sanitized: DomSanitizer) {
  }

  transform(metres: number, args?: any): any {
    return Math.round(metres * 0.00062137);
  }

}
